import { jsx as _jsx } from "react/jsx-runtime";
import isArray from "lodash/isArray";
import * as S from "./TextStyle.styled";
export var TextStyle = function (props) {
    var _a = props.element, element = _a === void 0 ? "span" : _a, children = props.children, _b = props.size, size = _b === void 0 ? "default" : _b, _c = props.variation, variation = _c === void 0 ? "default" : _c, _d = props.style, style = _d === void 0 ? {} : _d;
    return (_jsx(S.TextStyle, { as: element, variations: isArray(variation) ? variation : [variation], size: size, style: style, children: children }));
};
